import type {ReduxStore} from 'src/reducers';
import IndexStore from 'src/stores';

import * as React from 'react';
import {Provider} from 'react-redux';

import {getSentEvent} from 'src/actions/survey';
import {getAgencyConfig} from 'src/action-creators/agency';
import {getUserContentSubscriptionsExternalV2} from 'src/action-creators/content-subscription';

import FluxRoot from 'src/flux/root';
import ContentSubscriptionShell from 'src/components/shell/content-subscription';
import ErrorBoundary from 'src/components/500/boundary';
import ManageSubscriptionWrapper from 'src/components/content-subscription/manage/manage-subscription-wrapper';

import 'src/components/app.global.css';
import styles from 'src/components/app.css';

import css from './style.css';


export default function ContentSubscriptionApp({
  trackingId,
  sentEventId,
  unsubscribeCategoryId,
  attributeName,
  attributeValue,
  reduxStore,
  senseStore,
}: {
  trackingId?: string;
  sentEventId?: string;
  unsubscribeCategoryId?: string;
  reduxStore: ReduxStore;
  senseStore: IndexStore;
  attributeValue?: string;
  attributeName?: string;
}) {
  const commonParams = {
    unsubscribeCategoryId,
    attributeName,
    attributeValue,
  } as const;
  let params = {...commonParams};
  if (sentEventId) {
    const sentEvent = senseStore.sentEvents.byId(sentEventId);
    params = {
      ...commonParams,
      // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'sentEventId' does not exist in type '{ unsubscribeCategoryId: string | undefined; attributeName: string | undefined; attributeValue: string | undefined; }'.
      sentEventId,
      isDebugEntity: sentEvent.isDebug,
      deliveryAddress: sentEvent.deliveryAddress,
      entityId: sentEvent.recipientEntityId,
      entityType: sentEvent.recipientEntityType,
    };
  }
  /*Note(Vish): For J2 Emails, we get tracking ID instead of sentEventId,
  so the params are modified according to that. Check AEP-1924*/
  if (trackingId) {
    params = {
      // @ts-expect-error - TS2353 - Object literal may only specify known properties, and 'trackingId' does not exist in type '{ unsubscribeCategoryId: string | undefined; attributeName: string | undefined; attributeValue: string | undefined; }'.
      trackingId,
      ...commonParams,
    };
  }

  return (
    // @ts-expect-error - TS2786 - 'Provider' cannot be used as a JSX component.
    <Provider store={reduxStore}>
      <FluxRoot store={senseStore}>
        <div className={styles.container}>
          <div className={styles.body}>
            <ErrorBoundary>
              <ContentSubscriptionShell params={params}>
                <ManageSubscriptionWrapper params={params} />
              </ContentSubscriptionShell>
            </ErrorBoundary>
          </div>
        </div>
      </FluxRoot>
    </Provider>
  );
}

export function dependencies({
  store,
  dispatch,
  params: {sentEventId},
}: any): any {
  return Promise.all([
    getSentEvent(store, sentEventId),
    dispatch(getAgencyConfig()),
  ]);
}
